var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({attrs:{"label":_vm.t(_vm.status),"color":_vm.status,"icon-right":"expand_more","no-caps":""},on:{"click":function($event){return _vm.selectStatus()}}},'q-btn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }